
const API_DISALLOWED_FILETYPES: string[] = ['.js', '.css', '.xml', '.png', '.jpeg', '.jpg']

enum PRIORITY {
  LOW = 'low',
  MEDIUM = 'medium',
  HIGH = 'high',
}

const AGENT_CODE_CLEAN_TYPE = 'clean'

export { API_DISALLOWED_FILETYPES, PRIORITY, AGENT_CODE_CLEAN_TYPE }